import { useState, useRef } from "react";
import { api } from "@/lib/api";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const pad = (n) => String(n).padStart(3, "0");

// Mostra l'immagine ufficiale servita dal server SOLO se posseduta (cookie same-origin).
// L'immagine non viene mai ritagliata (object-contain). Se il file ufficiale non è
// ancora stato caricato, mostra uno stato onesto "da caricare" (nessun asset fittizio).
// `thumb`: miniatura leggera (~40 KB) per la griglia dell'album, caricata solo quando
// visibile (ticket 270476: 132 immagini HD da 300-400 KB restavano a meta' su Safari).
export const StickerImage = ({ number, className = "", alt, thumb = false }) => {
  const [err, setErr] = useState(false);
  const [retryToken, setRetryToken] = useState(0);
  const retriedRef = useRef(false);

  // L'<img> nativo non passa dall'istanza axios, quindi il rinnovo automatico
  // della sessione (interceptor in lib/api.js) non lo copre. Se il caricamento
  // fallisce (es. sessione scaduta -> 401), proviamo UNA volta a rinnovare la
  // sessione e a ricaricare l'immagine prima di mostrare il placeholder.
  const handleError = async () => {
    if (retriedRef.current) {
      setErr(true);
      return;
    }
    retriedRef.current = true;
    try {
      await api.post("/auth/refresh");
      setRetryToken((t) => t + 1);
    } catch {
      setErr(true);
    }
  };

  if (err) {
    return (
      <div
        data-testid={`sticker-missing-${pad(number)}`}
        className="w-full h-full flex flex-col items-center justify-center text-center text-[#b8ab9d] bg-[#faf1e6]"
      >
        <span className="font-bold text-xs">{pad(number)}</span>
        <span className="text-[8px] leading-tight px-0.5">da caricare</span>
      </div>
    );
  }

  const params = [];
  if (thumb) params.push("size=thumb");
  if (retryToken) params.push(`r=${retryToken}`);
  const query = params.length ? `?${params.join("&")}` : "";

  return (
    <img
      key={retryToken}
      src={`${BACKEND}/api/stickers/${number}${query}`}
      alt={alt || pad(number)}
      onError={handleError}
      loading={thumb ? "lazy" : undefined}
      decoding="async"
      className={className}
    />
  );
};
